import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { iUser } from "src/app/models/user.model";
import { BookService } from "src/app/services/book.service";
import { LocalStorageService } from "src/app/services/storage.service";
import { filters } from "./filtersData";
import { Subscription } from "rxjs";
import * as moment from 'moment';
import { MessageService } from "src/app/services/message.service";
import { description } from "src/app/models/books.model";
@Component({
  selector: "app-storico-novita",
  templateUrl: "./storico-novita.component.html",
  styleUrls: ["./storico-novita.component.scss"],
})
export class StoricoNovitaComponent implements OnInit, OnDestroy {
  books;
  loading = false;
  user: iUser;
  selectedBook;
  editoreFilter = 0;
  filters = filters;
  subscription: Subscription = null;
  editori : description[] = [];
  @Input() giro = null;


  constructor(
    private bookService: BookService,
    private toast: ToastrService,
    private localStorage: LocalStorageService,
    private messageservice: MessageService
  ) {}

  ngOnInit(): void {
    this.user = JSON.parse(sessionStorage.getItem("usr"));
     
    if (this.user.profile === 'admin' ) {
       this.getEditoriList();
    }
   
  }

   getEditoriList() {
     this.loading = true;
     const sub = this.bookService
      .editoriReport().subscribe({
        next: (data: description[]) => this.editori = data,
        error: (err) => console.error(err),
        complete: () => { this.loading = false;}
      });
     
  }

  /**
   * Vado a prendermi tutti i titoli che sono presenti nel catalogo e che sono usciti nel giro selezionato
   * @param anno anno del giro
   * @param numGiro numero del giro
   */
  getListaLanci(anno, numGiro, stato) {
    this.loading = true;
    const editore =(this.user.profile ==='admin') ? this.editoreFilter : this.user.code;
    this.subscription = this.bookService
      .getCollection(`libri/novita/${editore}/${anno}/${numGiro}/${stato}`)
      .subscribe({
        next: (data: any) => {
        
          this.books = data;
        },
        error: (err) => {
          console.error(err);
          this.toast.error("Errore nel recupero dei dati", "Errore");
        },
        complete: () => (this.loading = false),
      });
  }
  isNovita(book) { 
    if (book.stato === "I") {
      return true;
    }
    return false;
  }


  returnStatus(book) {
    const dataRecord = moment(book.data_pubblicazione, 'YYYYMMDD');
    const oggi = moment().startOf('day');

    if (dataRecord.isAfter(oggi) && book.stato === "I") {
      return "novita";
    }
    
    if (dataRecord.isBefore(oggi) && book.stato === "I") {
      return "scaduto";
    }
   
  }


  view(book) { 
    this.selectedBook = book;
  }
 
  closeBookForm() {
    this.selectedBook = null;
  }
  
   formatData(data) {
      return moment(data, 'YYYYMMDD').format('DD-MM-YYYY');
    }

  ngOnDestroy(): void {
      if(this.subscription){
        this.subscription.unsubscribe();
      }
  }
}
